import { useSelector } from "react-redux";
import styles from "./PromptModal.module.css";
import { useState, useEffect } from "react";
import { formatSeconds } from "../../../utilities/formatUtilities";
import { createCounter } from "../../../utilities/idleUtilities";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import { faWarning } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const PromptModal = () => {
    const isShowing = useSelector((state) => state.app.promptModal.show);
    const { body, countdownTo, title, displayIcon, buttonText, buttonAction, onClose } = useSelector((state) => state.app.promptModal.properties);
    const [renderBody, setRenderBody] = useState(body);
    const [counter, setCounter] = useState();
    const [secondsLeft, setSecondsLeft] = useState(null);
    const [theInterval, setTheInterval] = useState(null);

    useEffect(() => {
        if (counter && !theInterval) {
            setTheInterval(
                setInterval(() => {
                        setSecondsLeft(counter());
                }, 1000)
            );
        }
        return () => {
            clearInterval(theInterval);
            setInterval(null);
        };
    }, [counter, theInterval])

    useEffect(() => {
        if (body && renderBody && countdownTo && secondsLeft) {
            setRenderBody(body.replace('$countdown', formatSeconds(secondsLeft)));
        }
    }, [body, renderBody, counter, secondsLeft])

    useEffect(() => {
        setCounter(() => createCounter(countdownTo));//wrap in a function so that the returned function is saved in state
    }, [countdownTo])

    useEffect(() => {
        if (counter && Number.isFinite(secondsLeft) && secondsLeft <= 0) {
            onClose();
        }
    }, [secondsLeft])

    return (
    <Dialog open={isShowing}>
        <div className={styles.iconContainer}>
            {displayIcon &&
                <FontAwesomeIcon icon={faWarning} size="3x" className={styles.icon}/>
            }
            </div>
        <DialogTitle>
            <div className={styles.title}>{title}</div>
        </DialogTitle>
         <hr className={styles.divider}/>
        <DialogContent>
            <div dangerouslySetInnerHTML={{__html: renderBody?.replace("$countdown", formatSeconds(secondsLeft))}}></div>
        </DialogContent>
        <hr className={styles.divider}/>
        <DialogActions>
            <button onClick={buttonAction} className={styles.actionButton}>{buttonText}</button>
        </DialogActions>
    </Dialog>
    );
};
//Prompt supports a countdown but does not require it